export class InternalServerErrorException extends Error {
  public readonly statusCode: number = 500;
}
